// =============================================================================
// Back-office: correcciones de fichaje pendientes
// =============================================================================
import { apiClient } from './http';

/** Total de correcciones pendientes + lista (backend: PendingCorrectionsResponse). */
export interface CorrectionListItem {
  id: number;
  user_id: number;
  user_name: string;
  correction_date: string;
  // El ENUM `punchtype` del backend: IN/OUT/BREAK_START/BREAK_END. NO es el
  // vocabulario del sync (PUNCH_IN/PUNCH_OUT), que es otro.
  punch_type: 'IN' | 'OUT' | 'BREAK_START' | 'BREAK_END';
  proposed_time: string;
  original_time: string | null;
  // El motivo del trabajador (10-1000 chars, obligatorio al pedir la
  // corrección): es la diligencia debida de un INSERT retroactivo y el
  // responsable lo decide a la vista. El backend lo garantiza no-null en la
  // lista (r2b20[1], mitad backend).
  reason: string;
  status: string;
  created_at: string;
}

export async function getPendingCorrections(): Promise<{ total: number; corrections: CorrectionListItem[] }> {
  const res = await apiClient.get<{ total: number; corrections: CorrectionListItem[] }>('/corrections/pending');
  return res.data;
}

export async function decideCorrection(id: number, approved: boolean, rejectionReason?: string): Promise<void> {
  await apiClient.post(`/corrections/${id}/approve`, {
    approved,
    rejection_reason: rejectionReason,
  });
}
